import React from "react";

/**
 * A search snippet: `parts` is [{ text, hit }] from lib/searchEngine, so the
 * matched words are marked without rendering article HTML.
 */
const Snippet = ({ parts, className }) =>
  parts && parts.length > 0 ? (
    <span className={className}>
      {/* Index keys are fine: one snippet's parts never reorder. */}
      {parts.map((part, index) =>
        part.hit ? <mark key={index}>{part.text}</mark> : <React.Fragment key={index}>{part.text}</React.Fragment>
      )}
    </span>
  ) : null;

export default Snippet;
